import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";

const isProduction = import.meta.env.PROD;
const isDevelopment = import.meta.env.DEV;

export const store = configureStore({
  reducer: rootReducer,
  devTools: !isProduction,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: isDevelopment
        ? false
        : {
            // keep checking in production
            ignoredActions: ["apex/updateUserInfo", "identity/setKycResult"],
            ignoredPaths: ["apex.userInfo.dateOfBirth", "identity.dateOfBirth"],
          },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
